import React from 'react';
import PropTypes from 'prop-types';

import { FormCardSpaced, FlexBinaryChoiceRow } from 'modules/common';
import UpsellAmountMultiplierFooter from './amount-multiplier/footer.component';
import UpsellAmountMultiplierAmounts from './amount-multiplier/amounts.component';
import { mirrorAmountsForAmountType } from './amount-multiplier/tool';

function UpsellAmountMultiplier({ editedUpsell, onUpdateEditedUpsell, maxDonationAmounts, allowDescriptions = true }) {
  const onUpdateAmountType = ({ target: { name, value } }) => {
    const newEditedUpsell = {
      ...editedUpsell,
      [name]: value,
      page_amounts: mirrorAmountsForAmountType(editedUpsell.page_amounts, !!value),
    };

    onUpdateEditedUpsell({ target: { name: 'card', value: newEditedUpsell } });
  };

  return (
    <>
      <FormCardSpaced
        className="no-bottom-border-radius p-0"
        footer={
          <UpsellAmountMultiplierAmounts
            editedUpsell={editedUpsell}
            onUpdateEditedUpsell={onUpdateEditedUpsell}
            maxDonationAmounts={maxDonationAmounts}
            allowDescriptions={allowDescriptions}
          />
        }
      >
        <FlexBinaryChoiceRow
          trueText="Dynamic"
          falseText="Static"
          title="Donation Amount Buttons"
          subTitle="Customize your suggested donation amount buttons."
          value={editedUpsell.multiplier_amounts}
          disabled={editedUpsell._isDisabled}
          name="multiplier_amounts"
          onChange={onUpdateAmountType}
        />
      </FormCardSpaced>

      <UpsellAmountMultiplierFooter
        editedUpsell={editedUpsell}
        onUpdateEditedUpsell={onUpdateEditedUpsell}
        maxDonationAmounts={maxDonationAmounts}
      />
    </>
  );
}

UpsellAmountMultiplier.propTypes = {
  editedUpsell: PropTypes.object.isRequired,
  onUpdateEditedUpsell: PropTypes.func.isRequired,
  maxDonationAmounts: PropTypes.number,
  allowDescriptions: PropTypes.bool,
};

UpsellAmountMultiplier.defaultProps = {
  maxDonationAmounts: 9999,
};

export default UpsellAmountMultiplier;
